var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAsteriskLight = function SvgAsteriskLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009EFF",
    fillRule: "evenodd",
    d: "M96-10H64v41.373L34.745 2.118 12.118 24.745 41.373 54H0v32h41.373l-29.255 29.255 22.627 22.628L64 108.628V150h32v-41.373l29.255 29.255 22.627-22.627L118.627 86H160V54h-41.372l29.254-29.254-22.627-22.628L96 31.373z",
    clipRule: "evenodd"
  })));
};
export default SvgAsteriskLight;